import Rete from 'rete';

import VueTextControl from '../../components/commons/VueTextControl';


export default class TextControl extends Rete.Control {

	constructor(emitter, key, readonly, type = 'text') {
		// console.log(type);
		super(key);
		this.component = VueTextControl;
		this.props = { emitter, ikey: key, readonly };
	}

	setValue(val) {
		this.vueContext.value = val;
	}
}
